import * as type from '../../types';

export function getAllBusiness() {
    return {
        type: type.FETCH_GET_ALL_BUSINESS
    }
}